module.exports = __webpack_public_path__ + "media/application/images/svgs/carrot-arrow-left-89ec7fd9d4bb44b1a3d7a9191a6a3dc4.svg";